import { createContext } from 'react';
import noop from 'lodash/noop';

import type { AccordionContext as AccordionContextType } from '../types';

export const AccordionContext = createContext<AccordionContextType>({
  activeAccordionId: '',
  setActiveAccordionId: noop,
});
